module.exports = __webpack_public_path__ + "media/img/four_wheel-6d662038.svg";